<template>
  <audio
    v-if="player.currentItem.value?.mediaType === 'audio'"
    :ref="(el) => player.registerAudioEl(el as HTMLAudioElement | null)"
    :src="player.browserSrc.value"
    @timeupdate="player.onTimeUpdate"
    @loadedmetadata="player.onMetadata"
    @ended="player.onEnded"
    @play="player.browserPlaying.value = true"
    @pause="player.browserPlaying.value = false"
    preload="metadata" />
</template>

<script setup lang="ts">
import { useBrowserPlayer } from '@/composables/useBrowserPlayer';

const player = useBrowserPlayer();
</script>
